const PAGESIZE = 15;

/**
 * Calculate how many skeleton cards to show during loading.
 * Uses totalCount (from a prior successful fetch) and the current page number (from
 * shallow routing transitions) to match skeletons to expected results.
 *
 * Falls back to 9 on initial load when totalCount isn't yet available.
 */
export const getExpectedSkeletonCount = (totalCount, currentPage, pageSize = PAGESIZE) => {
  if (!totalCount || totalCount <= 0) return 9;
  const expectedCount = totalCount - (currentPage - 1) * pageSize;
  return Math.min(pageSize, Math.max(0, expectedCount));
};
